import { isNil } from 'lodash';
import { useQuery } from 'react-query';
import { getAssetsByID } from 'services/assets';
import { getFinAssetsByID } from 'services/finassets';

export function useGetAssetDetails(
  assetId?: number,
  phase?: 'PROD' | 'PROPOSAL',
  enabled: boolean = true
) {
  const finAssetQueryResult = useQuery(
    ['getFinAssetsByID', assetId],
    () =>
      getFinAssetsByID({ assetid: assetId! }).then((res) => {
        if (res.code === '403') {
          window.history.replaceState(null, '', '/403');
          window.location.reload();
        }
        return res.data;
      }),
    {
      enabled: !isNil(assetId) && phase === 'PROD' && enabled,
    }
  );

  const assetQueryResult = useQuery(
    ['getAssetsByID', assetId],
    () =>
      getAssetsByID({ assetid: assetId! }).then((res) => {
        if (res.code === '403') {
          window.history.replaceState(null, '', '/403');
          window.location.reload();
        }
        return res.data;
      }),
    {
      enabled: !isNil(assetId) && phase === 'PROPOSAL' && enabled,
    }
  );

  return phase === 'PROD' ? finAssetQueryResult : assetQueryResult;
}

export function useGetAssetUseDetails(
  assetId?: number,
  phase?: 'PROD' | 'PROPOSAL',
  enabled: boolean = true
) {
  const finAssetQueryResult = useQuery(
    ['getFinAssetsByID', assetId],
    () => getFinAssetsByID({ assetid: assetId! }).then((res) => res.data),
    {
      enabled: !isNil(assetId) && phase === 'PROD' && enabled,
    }
  );

  const assetQueryResult = useQuery(
    ['getAssetsByID', assetId],
    () => getAssetsByID({ assetid: assetId! }).then((res) => res.data),
    {
      enabled: !isNil(assetId) && phase === 'PROPOSAL' && enabled,
    }
  );

  return phase === 'PROD' ? finAssetQueryResult : assetQueryResult;
}
